import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import firebaseConfig from '../config/firebase-config';

class FirebaseAuthService {
	constructor() {
		this.app = null;
		this.auth = null;
		this.initialized = false;
	}

	init() {
		if (this.initialized && this.auth) return;

		try {
			this.app = firebase.apps.length
				? firebase.app()
				: firebase.initializeApp(firebaseConfig);
			this.auth = firebase.auth();
			this.initialized = true;
		} catch (error) {
			console.error('Erro ao inicializar Firebase:', error);
			throw error;
		}
	}

	async signInWithGoogle() {
		this.init();

		const provider = new firebase.auth.GoogleAuthProvider();
		provider.addScope('email');
		provider.addScope('profile');

		try {
			const result = await this.auth.signInWithPopup(provider);
			const user = result.user;
			const credential = result.credential || null;
			const firebaseIdToken = await user.getIdToken();
			const providerIdToken = credential ? credential.idToken : null;

			return {
				success: true,
				firebaseToken: firebaseIdToken,
				providerToken: providerIdToken,
				user: {
					uid: user.uid,
					email: user.email,
					displayName: user.displayName,
					photoURL: user.photoURL,
				},
			};
		} catch (error) {
			console.error('Erro no login Google:', error);

			if (error.code === 'auth/popup-closed-by-user') {
				return { success: false, error: 'Login cancelado pelo usuário' };
			}
			if (error.code === 'auth/popup-blocked') {
				return {
					success: false,
					error: 'Popup bloqueado. Permita popups para este site.',
				};
			}

			return {
				success: false,
				error: error.message || 'Erro ao fazer login com Google',
			};
		}
	}

	async signInWithApple() {
		this.init();

		const provider = new firebase.auth.OAuthProvider('apple.com');
		provider.addScope('email');
		provider.addScope('name');
		provider.setCustomParameters({
			locale: 'pt-BR',
		});

		try {
			const result = await this.auth.signInWithPopup(provider);
			const user = result.user;
			const credential = result.credential;
			const firebaseIdToken = await user.getIdToken();
			const providerIdToken = credential ? credential.idToken : null;

			return {
				success: true,
				firebaseToken: firebaseIdToken,
				providerToken: providerIdToken,
				user: {
					uid: user.uid,
					email: user.email,
					displayName: user.displayName,
					photoURL: user.photoURL,
				},
				credential: {
					accessToken: credential ? credential.accessToken : null,
					idToken: credential ? credential.idToken : null,
				},
			};
		} catch (error) {
			console.error('Erro no login Apple:', error);

			if (error.code === 'auth/popup-closed-by-user') {
				return { success: false, error: 'Login cancelado pelo usuário' };
			}
			if (error.code === 'auth/popup-blocked') {
				return {
					success: false,
					error: 'Popup bloqueado. Permita popups para este site.',
				};
			}
			if (error.code === 'auth/account-exists-with-different-credential') {
				return {
					success: false,
					error: 'Esta conta já existe com outro método de login',
				};
			}

			return {
				success: false,
				error: error.message || 'Erro ao fazer login com Apple',
			};
		}
	}

	async signOut() {
		this.init();

		try {
			await this.auth.signOut();
		} catch (error) {
			console.error('Erro no logout:', error);
		}
	}

	getCurrentUser() {
		this.init();
		return this.auth.currentUser;
	}
}

export default new FirebaseAuthService();
